import React from "react";
import styles from "./styles.css";
var TopPickBadge = function TopPickBadge(_ref) {
  var product = _ref.product;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.topPickBadge
  }, /*#__PURE__*/React.createElement("span", null, "Top pick"));
};
export default TopPickBadge;